import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';

// Constants
import { rutasCotizar } from '../../../../common/constants';

// Hooks
import { CotizadorProvider } from '../../../../hooks/context';

// Pages
import {
  Blog,
  BlogDetalle,
  Conocenos,
  Contacto,
  Cotizar,
  Error404,
  Error500,
  FormularioCotizar,
  Home,
  Informativa,
  PreguntasFrecuentes,
  TerminosCondiciones,
} from '../../../pages';

// Templates
import { Layout } from '../../../templates';

// Utils
import { changeSEO } from '../../../../core/utils';

export function RouterAsegurame() {
  const location = useLocation();

  useQuery({
    queryKey: ['seo', location.pathname],
    queryFn: changeSEO,
  });

  return (
    <Layout>
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/conocenos" element={<Conocenos />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-detalle" element={<BlogDetalle />} />
        <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />
        <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
        <Route path="/contactanos" element={<Contacto />} />
        <Route path="/deducible-vehiculo" element={<Informativa />} />
        <Route path="/enfermedades-graves" element={<Informativa />} />
        <Route path="/seguro-viaje" element={<Informativa />} />
        <Route path="/seguro-oncologico-plus" element={<Informativa />} />
        <Route path="/seguro-plenisalud" element={<Informativa />} />
        <Route path="/seguro-vida-plus" element={<Informativa />} />

        <Route
          path="/cotizar"
          element={
            <CotizadorProvider>
              <Cotizar />
            </CotizadorProvider>
          }
        />
        {rutasCotizar.map(ruta => (
          <Route
            key={ruta.codigo}
            path={ruta.ruta}
            element={
              <CotizadorProvider>
                <FormularioCotizar />
              </CotizadorProvider>
            }
          />
        ))}
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="*" element={<Navigate to="/page-error-404" replace />} />
      </Routes>
    </Layout>
  );
}
